import React from 'react';

interface WordmarkProps {
  size?: number;
  color?: string;
  showIcon?: boolean;
}

export function Wordmark({ size = 28, color = '#EDEDED', showIcon = true }: WordmarkProps) {
  const iconSize = size * 1.05;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: size * 0.32 }}>
      {showIcon && (
        <img
          src="/images/mooncloak_logo_512.png"
          alt=""
          width={iconSize}
          height={iconSize}
          style={{ flex: 'none' }}
        />
      )}
      <div
        style={{
          fontFamily: '"MoonCloak","Inter",system-ui',
          fontSize: size,
          lineHeight: 1,
          color,
          letterSpacing: '-0.015em',
          fontWeight: 400,
        }}
      >
        mooncloak
      </div>
    </div>
  );
}
